import { Filter } from '@anytag/shared-molecules';
import { Template, TemplateProps } from './Template';
import { useAutoManagedCommissionsFilter } from './hooks';

export type AutoManagedCommissionsFilterProps = Omit<TemplateProps, 'onSubmit'>;

export const AutoManagedCommissionsFilter = (props: AutoManagedCommissionsFilterProps) => {
  const { filter, setFilterForm } = useAutoManagedCommissionsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template {...props} />
    </Filter.Provider>
  );
};

export { useAutoManagedCommissionsFilter };
export * from './schemaTypes';
